"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _sideBySideBuilder = require("./sideBySideBuilder");
Object.keys(_sideBySideBuilder).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _sideBySideBuilder[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _sideBySideBuilder[key];
    }
  });
});